<ng-container *ngTemplateOutlet="mode() === 'home' ? homefilter : nohomefilter"></ng-container>

<ng-template #homefilter>
    @switch (mediaService.media()) {
    @case ('xs') {
    <ng-container *ngTemplateOutlet="homemodeMobile"></ng-container>
    }
    @case ('sm') {
    <ng-container *ngTemplateOutlet="homemodeMobile"></ng-container>
    }
    @case ('md') {
    <ng-container *ngTemplateOutlet="homemodeMobile"></ng-container>
    }
    @default {
    <ng-container *ngTemplateOutlet="homefilterdesk"></ng-container>
    }
    }
</ng-template>

<ng-template #nohomefilter>
    @if(mode() === 'nohomesmall') {
    {{(zielText()) + ' ' + (ziel())}}
    } @else {
    <ng-container *ngTemplateOutlet="homemodeMobile"></ng-container>
    }
</ng-template>
<!-- 
<ng-template #mbfilters>
    <button class="tmpbtn w100 tmpnobottomborder" #mdbuttonMobile="cdkOverlayOrigin" cdkOverlayOrigin
        (click)="openModalMobile($event)" matRipple>
        <mat-icon fontIcon="train"></mat-icon>
        <span>{{zielText + ' Abfahrtsbahnhof'}}</span>
    </button>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttonMobile"
        [cdkConnectedOverlayFlexibleDimensions]="true" [cdkConnectedOverlayOpen]="showModal"
        [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="closeModalMobile()">
        <ng-container *ngTemplateOutlet="modal"></ng-container>
    </ng-template>
</ng-template> -->


<ng-template #homemodeMobile>
    <!-- <button class="tmpbtn tmpnorightborder w100 tmp-bottom-left" #mdbuttonMobile="cdkOverlayOrigin" cdkOverlayOrigin
        (click)="openModalMobile($event)" matRipple>
        <mat-icon fontIcon="train"></mat-icon>
        <span>{{zielText}}</span>
    </button>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttonMobile"
        [cdkConnectedOverlayFlexibleDimensions]="true" [cdkConnectedOverlayOpen]="showModal"
        [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="closeModalMobile()">
        <ng-container *ngTemplateOutlet="modal"></ng-container>
    </ng-template> -->

    <div class="searchBoxWrapper_mobile customflex" #mdbuttondesk="cdkOverlayOrigin"
        [class.searchBoxWrapperactive]="showModal()" cdkOverlayOrigin (click)="openModal()" ng-clickOutside
        (clickOutside)="closeModal()">
        <div class="wrapper">
            <span class="description">{{ziel()}}</span>
            <div class="searchinputwrapper">
                <input type="text" placeholder="{{showModal() ? '': zielText()}}" [class.inputactive]="showModal()"
                    [formControl]="mySearchControl" ng-focus [appAutoFocus]="focus()" class="searchinput">
                @if(mySearchControl?.value?.length > 0) {
                <button (click)="clearText()" class="closesection">
                    <img src="../../../../assets/tvg/close.svg" alt="close">
                </button>
                }
            </div>
        </div>
        <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttondesk"
            [cdkConnectedOverlayPositions]="overlaypos" [cdkConnectedOverlayOpen]="showModal()"
            [cdkConnectedOverlayHasBackdrop]="false" (backdropClick)="closeModal()">
            <ng-container *ngTemplateOutlet="modal"></ng-container>
        </ng-template>
    </div>
</ng-template>

<ng-template #homefilterdesk>
    <!-- <button class="tmpbtn tmpnorightborder w100" #mdbuttondesk="cdkOverlayOrigin" cdkOverlayOrigin
        (click)="openModal($event)" matRipple>
        <mat-icon fontIcon="train"></mat-icon>
        <span>{{zielText}}</span>
    </button>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttondesk"
        [cdkConnectedOverlayFlexibleDimensions]="true" [cdkConnectedOverlayOpen]="showModal"
        [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="closeModal()">
        <ng-container *ngTemplateOutlet="modal"></ng-container>
    </ng-template> -->
    <div class="searchBoxWrapper" #mdbuttondesk="cdkOverlayOrigin" [class.searchBoxWrapperactive]="showModal()"
        cdkOverlayOrigin (click)="openModal()" ng-clickOutside (clickOutside)="closeModal()">
        <div class="wrapper">
            <span class="description">{{ziel()}}</span>
            <div class="searchinputwrapper">
                <input type="text" placeholder="{{showModal() ? '': zielText()}}" [class.inputactive]="showModal()"
                    [formControl]="mySearchControl" ng-focus [appAutoFocus]="focus()" class="searchinput">
                @if(mySearchControl?.value?.length > 0) {
                <button (click)="clearText()" class="closesection">
                    <img src="../../../../assets/tvg/close.svg" alt="close">
                </button>
                }
            </div>
        </div>
        <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttondesk"
            [cdkConnectedOverlayPositions]="overlaypos" [cdkConnectedOverlayOpen]="showModal()"
            [cdkConnectedOverlayHasBackdrop]="false" (backdropClick)="closeModal()">
            <ng-container *ngTemplateOutlet="modal"></ng-container>
        </ng-template>
    </div>
</ng-template>


<ng-template #modal>
    @switch (mediaService.media()) {
    @case ('xs') {
    <ng-container *ngTemplateOutlet="mobileModal"></ng-container>
    }
    @case ('sm') {
    <ng-container *ngTemplateOutlet="mobileModal"></ng-container>
    }
    @default {
    <ng-container *ngTemplateOutlet="mobileDesk"></ng-container>
    }
    }
</ng-template>


<ng-template #mobileDesk>
    <!-- <div class="backdropwrapper mat-elevation-z1" [@zoom]="origin">
        <div class="filterwrapper">
            <div class="f-headerwrapper">
                <input type="text" placeholder="Abfahrtsbahnhof hinzufügen" [formControl]="mySearchControl" ng-focus
                    [appAutoFocus]="focus" class="searchinput">
                <button matRipple (click)="clearText()" *ngIf="mySearchControl?.value?.length > 0">
                    <mat-icon class="btnico">clear</mat-icon>
                </button>
            </div>
            <ng-container *ngTemplateOutlet="datassection"></ng-container>
        </div>
    </div> -->
    <div class="custompopupwrapper mat-elevation-z1">
        <div class="popupbody">
            <ng-container *ngTemplateOutlet="datassection"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #mobileModal>
    <!-- <div class="backdropwrapper-mobile" [@zoom]="origin">
        <div class="filterwrapper-mobile">
            <div class="f-headerwrapper">
                <button matRipple (click)="closeModalMobile()">
                    <mat-icon class="btnico-mobile">arrow_back</mat-icon>
                </button>
                <input type="text" placeholder="Abfahrtsbahnhof hinzufügen" [formControl]="mySearchControl" ng-focus
                    [appAutoFocus]="focus" class="searchinput">
            </div>
            <ng-container *ngTemplateOutlet="datassection"></ng-container>
        </div>
    </div> -->
    <div class="backdropwrapper-mobile">
        <div class="filterwrapper-mobile">
            <button class="shettheader" (click)="closeModalMobile()" #searchheader>
                <img src="../../../../../assets/tvg/leftdirection.svg" alt="goback icon">
                <span>Wo fahren Sie los?</span>
            </button>
            <div class="searchBoxWrapper customflex" #mdbuttondesk="cdkOverlayOrigin"
                [class.searchBoxWrapperactive]="showModal()" cdkOverlayOrigin (click)="openModal()" ng-clickOutside
                (clickOutside)="closeModal()">
                <div class="wrapper" (click)="$event.stopPropagation()">
                    <span class="description">{{ziel()}}</span>
                    <div class="searchinputwrapper">
                        <input type="text" placeholder="{{showModal() ? '': zielText()}}"
                            [class.inputactive]="showModal()" [formControl]="mySearchControl" ng-focus
                            [appAutoFocus]="focus()" class="searchinput">
                        @if(mySearchControl?.value?.length > 0) {
                        <button (click)="clearText()" class="closesection">
                            <img src="../../../../assets/tvg/close.svg" alt="close">
                        </button>
                        }
                    </div>
                </div>
            </div>
            <div class="custompopupwrapper-mobile">
                <div class="popupbody">
                    <ng-container *ngTemplateOutlet="datassection"></ng-container>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #datassection>
    <!-- <div class="f-bodywrapper" [class.f-bodywrapper-mobile]="media === 'xs' || media=== 'sm'">
        <ng-container *ngIf="selectedList?.length > 0">
            <div class="selected-wrapper">
                <button class="selected-item-alle" (click)="removeAllSelected()">
                    <span>Alles löschen</span>
                </button>
                <ng-container *ngFor="let item of selectedList; let k = index">
                    <div class="selected-item">
                        <span>{{item.name}} <span class="second-item-line">{{item.code}}</span></span>
                        <button (click)="removeFromSelected(k)">
                            <mat-icon class="clearbtn">clear</mat-icon>
                        </button>
                    </div>
                </ng-container>
            </div>
        </ng-container>
        <ng-container *ngFor="let item of (searchObj | async)">
            <ng-container *ngIf="isNotInlist(item)">
                <button class="item-wrapper" (click)="selectValue(item)">
                    <div class="item-body">
                        <span class="first-item-line">{{item.name}} <span
                                class="second-item-line">{{item.code}}</span></span>
                    </div>
                </button>
            </ng-container>
        </ng-container>
    </div>
    <div class="ubwrapper">
        <button class="ubbtn" (click)="take()">ÜBERNEHMEN</button>
    </div> -->
    <div class="resultatwrapper customscroll" (click)="$event.stopPropagation()">
        @if(selectedList()?.length > 0) {
        <div class="selected-wrapper">
            <button class="selected-item-alle" (click)="removeAllSelected()">
                <span>{{'Alles löschen'}}</span>
            </button>
            @for (item of selectedList(); let k = $index; track k) {
            <div class="selected-item">
                <span>{{item.name}} <span class="second-item-line">{{item.code}}</span></span>
                <button (click)="removeFromSelected(k)">
                    <mat-icon class="clearbtn">clear</mat-icon>
                </button>
            </div>
            }
        </div>
        }
        @if(mySearchControl?.value?.length > 0 && (searchObj | async); as airports) {
        @for (item of airports; track $index) {
        @if(isNotInlist(item)) {
        <button class="item-wrapper" (click)="selectValue(item)">
            <div class="item-body">
                <span class="first-item-line">{{item.name}} <span class="second-item-line">{{item.code}}</span></span>
            </div>
        </button>
        }
        }
        }
    </div>
    <div class="ubwrapper">
        <button class="custombutton customblue_unfilled w50" (click)="removeAllSelected()">Auswahl
            aufheben</button>
        <button class="custombutton customunfilled w50" (click)="take()">Übernehmen {{selectedList()?.length > 0 ? '(' +
            selectedList().length + ')' : ''}}</button>
    </div>
</ng-template>